import { createAction } from 'redux-actions';

export const GetListOptionsRequested = createAction('GET_LIST_OPTIONS_REQUESTED');
export const GetListOptionsReceived = createAction('GET_LIST_OPTIONS_RECEIVED');
export const GetListOptionsReceiveFailure = createAction('GET_LIST_OPTIONS_RECEIVE_FAILURE');

export const GetJobsRequested = createAction('GET_JOBS_REQUESTED');
export const GetJobsRequestedReceived = createAction('GET_JOBS_REQUESTED_RECEIVED');
export const GetJobsRequestedReceivedFailure = createAction('GET_JOBS_REQUESTED_RECEIVED_FAILURE');

export const GetZonesRequested = createAction('GET_ZONES_REQUESTED');
export const GetZonesRequestedReceived = createAction('GET_ZONES_REQUESTED_RECEIVED');
export const GetZonesRequestedReceivedFailure = createAction('GET_ZONES_REQUESTED_RECEIVED_FAILURE');
export const ClearEventZone = createAction('CLEAR_EVENT_ZONE');

export const GetZonesStatusRequested = createAction('GET_ZONES_STATUS_REQUESTED');
export const GetZonesStatusReceived = createAction('GET_ZONES_STATUS_RECEIVED');
export const GetZonesStatusFailure = createAction('GET_ZONES_STATUS_FAILURE');

export const GetCategoryRequest = createAction('GET_CATEGORY_REQUEST');
export const GetCategoryReceived = createAction('GET_CATEGORY_RECEIVED');
export const GetCategoryFailure = createAction('GET_CATEGORY_FAILURE');
//export const ClearCategory = createAction('CLEAR_CATEGORY');

export const GetOccupationRequest = createAction('GET_OCCUPATION_REQUEST');
export const GetOccupationReceived = createAction('GET_OCCUPATION_RECEIVED');
export const GetOccupationFailure = createAction('GET_OCCUPATION_FAILURE');
export const ClearOccupation = createAction('CLEAR_OCCUPATION');
